<template>
  <div id="join-modal-template">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper join-modal">
          <div class="modal-container md-modal-container">
            <div class="modal-body">
              <h2 class="show-title" v-if="(this.paramStr !== 'reJoin')">커뮤니티 가입신청</h2>
              <h2 class="show-title" v-if="(this.paramStr === 'reJoin')">커뮤니티 가입 재신청</h2>
              <!-- form class="form-horizontal" -->
              <table class="table table-bordered text-center table-system-authority-roles"><caption>커뮤니티 가입 신청자 정보</caption>
                <tr><td colspan=2 style="text-align: left; font-weight: bold;">구성원정보</td></tr>
                <tr><td style="text-align: left;">&nbsp;</td></tr>
                <tr>
                  <td style="text-align: left;">이&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;름 <input type="text" placeholder="이름을 입력해 주세요." class="input__text" v-model="name" style="text-align: left; width:48%;" title="이름을 입력해 주세요."></td>
                </tr>
                <tr><td style="text-align: left;">&nbsp;</td></tr>
                <tr>
                  <td style="text-align: left;" width="10%">전화번호 <input type="text" placeholder="전화번호1" class="input__text" v-model="phone1" style="width:15%;" title="전화번호1">-
                  <input type="text" placeholder="전화번호2" class="input__text" v-model="phone2" style="width:15%;" title="전화번호2">-
                  <input type="text" placeholder="전화번호3" class="input__text" v-model="phone3" style="width:15%;" title="전화번호3"></td>
                </tr>
                <tr><td style="text-align: left;">&nbsp;</td></tr>
                <tr>
                <tr><td colspan=2 style="text-align: left; font-weight: bold;">커뮤니티 신청 메세지</td></tr>
                <tr>
                  <td style="width:100%; height:200px;">
                    <textarea class="input__textarea input__textarea--thin" v-model="reason" rows="2" style="width:98%; height:98%;" title="결과 입력"></textarea>
                  </td>
                </tr>
              </table>
              <!-- /form -->
              <div class="attendance-action">
                <button class="sm-btn btn--blue-line" @click="close">닫기</button>
                <button class="sm-btn btn--blue-line" @click="save">저장</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import Axios from 'axios';
  
  export default {
    name: 'join-modal-template',
    props: ['communityId', 'loginMember', 'reJoinTxt'],
    data() {
      return {
        showModal: false,
        communityIdStr: 1,
        member: null,
        reason: '',
        name: '',
        loginid: '',
        id: '',
        birthdate: '',
        phone1: '',
        phone2: '',
        phone3: '',
        email: '',
        addr1: '',
        addr2: '',
        paramStr: '',
        sendUrl: `/admin/api/community/communities/${this.id}/members`,
      };
    },
    computed: {
    },
    methods: {
      setButtons() {
      },
      addCommunityMember({ id, params, completeFn, errorFn }) {
        Axios.put(`/api/communities/${id}/members_community`, params, { params: { reason: this.reason, status: 'REGIST' } }).then(() => {
          /* const community = res.data || []; */
          /* commit(types.ADD_COMMUNITYMEMBER, { community }); */
          completeFn();
          this.close();
        }).catch((e) => {
          errorFn(e.response);
        });
      },
      modifyCommunityMember({ id, params, completeFn, errorFn }) {
        Axios.put(`/api/communities/${id}/members_rejoin`, params, { params: { reason: this.reason, status: 'RE_REQUEST' } }).then(() => {
          /* const community = res.data || []; */
          /* commit(types.ADD_COMMUNITYMEMBER, { community }); */
          completeFn();
          this.close();
        }).catch((e) => {
          errorFn(e.response);
        });
      },
      save() {
        if (this.paramStr === 'reJoin') {
          const result = window.confirm('재신청 하시겠습니까?');
          if (result) {
            if (this.reason.length > 30) {
              alert('신청 메시지를 30자 이내로 변경합니다.');
              this.reason = this.reason.slice(0, 30);
            }
            if (this.reason.length < 1) {
              alert('신청 메시지를 입력해 주세요.');
              return;
            }
            const Params = {
              id: this.communityIdStr,
              name: this.loginMember.name,
              email: this.loginMember.email,
              phone1: this.loginMember.phone1,
              phone2: this.loginMember.phone2,
              phone3: this.loginMember.phone3,
              addrCity: this.loginMember.addr1,
              addrGu: this.loginMember.addr2,
              birthdate: this.loginMember.birthdate,
              role: '신청자_재신청',
              memberId: this.loginMember.loginid,
              reason: this.reason,
              status: 'RE_REQUEST',
            };
            this.modifyCommunityMember({
              id: this.communityIdStr,
              reason: this.reason,
              params: Params,
              completeFn: () => {
                alert('재신청 되었습니다.');
              },
              errorFn: (e) => {
                alert(e.data.msg);
              },
            });
          }
        } else {
          const result = window.confirm('신청 하시겠습니까?');
          if (result) {
            if (this.reason.length > 30) {
              alert('신청 메시지를 30자 이내로 변경합니다.');
              this.reason = this.reason.slice(0, 30);
            }
            if (this.reason.length < 1) {
              alert('신청 메시지를 입력해 주세요.');
              return;
            }
            const Params = {
              id: this.communityIdStr,
              name: this.loginMember.name,
              email: this.loginMember.email,
              phone1: this.loginMember.phone1,
              phone2: this.loginMember.phone2,
              phone3: this.loginMember.phone3,
              addrCity: this.loginMember.addr1,
              addrGu: this.loginMember.addr2,
              birthdate: this.loginMember.birthdate,
              role: '신청자_신규',
              memberId: this.loginMember.loginid,
              reason: this.reason,
              status: 'REGIST',
            };
            this.addCommunityMember({
              id: this.communityIdStr,
              params: Params,
              completeFn: () => {
                alert('가입신청이 완료되었습니다. 승인 및 반려 사항을 확인하세요');
              },
              errorFn: (e) => {
                alert(e.data.msg);
              },
            });
          }
        }
      },
      close() {
        this.showModal = false;
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
        location.reload();
      },
    },
    mounted() {
      this.communityIdStr = this.communityId;
      this.id = this.loginMember.loginid;
      this.name = this.loginMember.name;
      this.phone1 = this.loginMember.phone1;
      this.phone2 = this.loginMember.phone2;
      this.phone3 = this.loginMember.phone3;
      this.addrCity = this.loginMember.addr1;
      this.addrGu = this.loginMember.addr2;
      this.birthdate = this.loginMember.birthdate;
      this.role = this.loginMember.role;
      this.paramStr = this.reJoinTxt;
      $('body').addClass('modal-open');
      this.showModal = true;
    },
    created() {
    },
  };
</script>



// WEBPACK FOOTER //
// MemberJoinButton.vue?dc00cd8e